import { CRTrackerColumns } from '@ge/shared/models/table-col-defs/cr-tracker-table-cols';

export const defaultCrTrackerCols = [
  {
    id: CRTrackerColumns.GROUP_MONTH,
    cols: [
      {
        id: CRTrackerColumns.MONTH,
        visible: true,
      },
    ],
  },
  // {
  //   id: CRTrackerColumns.GROUP_PROD,
  //   cols: [
  //     {
  //       id: CRTrackerColumns.PROD,
  //       visible: true,
  //     },
  //   ],
  // },
  // {
  //   id: CRTrackerColumns.GROUP_LP,
  //   cols: [
  //     {
  //       id: CRTrackerColumns.LP,
  //       visible: true,
  //     },
  //   ],
  // },
  {
    id: CRTrackerColumns.GROUP_CONTRACTUAL_AVAILABILITY,
    cols: [
      {
        id: CRTrackerColumns.CONTRACTUAL_AVAILABILITY,
        visible: true,
      },
    ],
  },
  {
    id: CRTrackerColumns.GROUP_MALS_ADDED,
    cols: [
      {
        id: CRTrackerColumns.MALS_ADDED,
        visible: true,
      },
    ],
  },
  {
    id: CRTrackerColumns.GROUP_MALS_APPROVED,
    cols: [
      {
        id: CRTrackerColumns.MALS_APPROVED,
        visible: true,
      },
    ],
  },
  {
    id: CRTrackerColumns.GROUP_MALS_REJECTED,
    cols: [
      {
        id: CRTrackerColumns.MALS_REJECTED,
        visible: true,
      },
    ],
  },
  {
    id: CRTrackerColumns.GROUP_MALS_NOT_VALIDATED,
    cols: [
      {
        id: CRTrackerColumns.MALS_NOT_VALIDATED,
        visible: true,
      },
    ],
  },
  {
    id: CRTrackerColumns.GROUP_LOCK_MONTH,
    cols: [
      {
        id: CRTrackerColumns.LOCK_MONTH,
        visible: true,
      },
    ],
  },
  {
    id: CRTrackerColumns.GROUP_LOCK_MONTH_DATE,
    cols: [
      {
        id: CRTrackerColumns.LOCK_MONTH_DATE,
        visible: true,
      },
    ],
  },
  {
    id: CRTrackerColumns.GROUP_LOCK_DONE_BY_SSO,
    cols: [
      {
        id: CRTrackerColumns.LOCK_DONE_BY_SSO,
        visible: true,
      },
    ],
  },
  {
    id: CRTrackerColumns.GROUP_MALS_SUBMISSION_DATE,
    cols: [
      {
        id: CRTrackerColumns.MALS_SUBMISSION_DATE,
        visible: true,
      },
    ],
  },
  {
    id: CRTrackerColumns.GROUP_STATUS_UPDATE,
    cols: [
      {
        id: CRTrackerColumns.STATUS_UPDATE,
        visible: true,
      },
    ],
  },
];
